


































































import Vue from 'vue';
import layout from '@/libs/layout/educational/lesson-student';
import { Component, Prop } from 'vue-property-decorator';
import {
  TLessonStudentSearch,
  TLessonStudentPage,
  TLessonStudentList
} from '@/types/views/educational';
import { getLessonStudentPage, sendCommentNotify } from '@/api/educational';
import { TLayout } from '@/types/utils';
@Component({
  components: {
    Comment: () => import('./comment.vue')
  }
})
export default class Student extends Vue {
  @Prop({
    type: String,
    required: true
  })
  courseId!: string;
  private layout: TLayout = layout;
  private page: TLessonStudentPage = {
    currentPage: 1,
    pageSize: 20
  };
  private searchOptions: TLessonStudentSearch = {
    courseId: '',
    lessonId: '',
    currentPage: 1,
    pageSize: 20
  };
  private mounted() {
    console.log("进入mounted")
    this.reload();
  }
  private activated() {
    console.log("进入activated")
    this.reload();
  }
  private commenter: TLessonStudentList = {}
  private handlePage(page: number) {
    this.searchOptions = { ...this.searchOptions, ...{ currentPage: page } };
    this.getStudentPage();
  }
  private handleSize(size: number) {
    this.searchOptions = { ...this.searchOptions, ...{ pageSize: size } };
    this.getStudentPage();
  }
  private renderIndex(index: number) {
    return index + 1 + (this.page.currentPage - 1) * this.page.pageSize || 0;
  }
  private reload() {
    this.searchOptions = {
      courseId: this.courseId,
      lessonId: this.$route.params.id,
      currentPage: 1,
      pageSize: 20
    };
    this.getStudentPage();
  }
  private goToProject(project: TLessonStudentList) {
    const url = `${process.env.VUE_APP_URL}/create?projectId=${project.id}`;
    window.open(url, '_blank');
  }
  /**
   * @description: 获取学员列表
   */
  private async getStudentPage() {
    try {
      this.page = await getLessonStudentPage(this.searchOptions);
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  /**
   * @description: 推送老师点评信息
   * @param {number} id 学员ID
   */
  private async sendCommentNotify(id: number) {
    try {
      const res = await sendCommentNotify({
        userLessonId: id
      });
      if (res.code === '000001') {
        this.$message.success(res.message);
      }
      this.reload();
    } catch (err) {
      this.$message.error(err.message);
    }
  }
  private openDialog(row: TLessonStudentList) {
    this.commenter = row;
    (this.$refs.comment as any).dialogVisible = true
  }
}
